import { useState, useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { PATHNAMES } from "../../../utils/admin-routing-utils";
import WaitingIndicator from "../../general-ui/waiting-indicator/waiting-indicator";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { ReactComponent as BrandliveLogo } from '../../../images/BrandLive_Logo.svg';
import Search from "../../general-ui/search-bar/search";

import './admin-side-nav.scss';
import { useProjectDetailsEnabled } from '@admin/events/hooks/project-details';
import ChannelAvatar from './channel-selection/channel-avatar';
import { useChannelSelect } from './channel-selection/hooks/use-channel-select';
import { useHistory } from 'react-router';

export default function AdminSideNav(): JSX.Element {
	const user = useTypedSelector(state => state.AuthReducer.user);
	const channels = useTypedSelector(state => state.AuthReducer.channels);
	const projectDetailsFlagOn = useProjectDetailsEnabled();
	const history = useHistory();
	const { selectChannel } = useChannelSelect({
		onChannelSelectSuccess: () => {
			history.push(PATHNAMES.Events);
			window.location.reload();
		},
	});

	const [clicked, setClicked] = useState(false);
	const [searchCriteria, setSearchCriteria] = useState('');

	const activeChannel = useMemo(() => user?.active_channel, [user]);


	if (projectDetailsFlagOn) {
		return <></>;
	}

	return user ? (
		<div className={`admin-side-nav ${clicked ? "clicked" : ''}`}>
			<div className="admin-side-nav-container">
				<Link to={PATHNAMES.Events}>
					<BrandliveLogo className="brandlive-icon" />
				</Link>
				<div className="channels-wrapper">
					{channels.filter(channel => channel.name.toLowerCase().includes(searchCriteria.toLowerCase())).map(channel => (
						<div
							id={channel.uuid}
							title={channel.name}
							className={classNames('channel-wrapper', { active: activeChannel === channel.channel })}
							key={channel.uuid}
							onClick={() => user.active_channel !== channel.channel ? selectChannel(channel) : null}
						>
							<div className="colored-border">
								<div className="transparent-container">
									<ChannelAvatar channel={channel} />
								</div>
							</div>

							<div className="channel-name">
								{channel.name}
							</div>
						</div>
					))}
				</div>
				<div className="channel-search-container">
					<Search
						onSearch={value => setSearchCriteria(value)}
						onClear={() => setSearchCriteria('')}
						onChange={value => setSearchCriteria(value)}
						autoFocus
						placeholder="Search channels"
					/>
				</div>
			</div>
		</div>
	) : (
		<WaitingIndicator minHeight={'90vh'} fillSpace={true} />
	);
}
